<div mat-dialog-title class="ds">
  <span>{{ appStrings.products_ATP }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon id="closeButton" class="close-icon">close</mat-icon>
  </button>
</div>
@if (isLoading) {
  <div class="loading center" [ngClass]="{'large': !isMobile}">
    <ds-progress-spinner id="loading" progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}
@if (!isLoading) {
  <div id="formContainer" mat-dialog-content class="content ds container" [ngClass]="{'large': !isMobile}">
    <div class="product-name">
      <typography variant="body-2" weight="medium"> {{ appStrings.products_product }}: {{ atpValues[0].partNumber }} </typography>
    </div>
    @for (warehouse of atpValues; track warehouse) {
      <div class="warehouse-container">
        <ds-paper class="full-width-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
          insidePaddingTop="top-spacing_3XS">
          <div class="warehouse-name">
            <typography variant="body-2" weight="medium"> {{ warehouse.warehouse }}@if (!isUkCountry) {<span>: {{ warehouse.warehouseName }}</span>} </typography>
          </div>
          <ds-table mat-table [dataSource]="warehouse.inventories" [displayedColumns]="displayedColumns">
            <ng-container matColumnDef="availableQuantity">
              <th mat-header-cell *matHeaderCellDef> {{ appStrings.products_availableItemsColumn }} </th>
              <td mat-cell *matCellDef="let item;let i = dataIndex" [id]="'availableQuantity'+i">
                {{ item.availableQuantity }}
              </td>
            </ng-container>
            <ng-container matColumnDef="receiptDate">
              <th mat-header-cell *matHeaderCellDef> {{ appStrings.products_dateATPColumn }} </th>
              <td mat-cell *matCellDef="let item;let i = dataIndex" [id]="'receiptDate'+i">
                {{ item.receiptDate.toString() | date: appInfoService.dateFormat }}
              </td>
            </ng-container>
          </ds-table>
        </ds-paper>
      </div>
    }
  </div>
}
<div id="dialog-actions" mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="closeButton" variant="label-only" size="medium" type="secondary" (onClick)="close()" [label]="appStrings.button_close"></ds-button>
  </div>
</div>

<!-- common -->
<ng-template #noWarehouses>
<div class="no-entries">
  <span class="no-results">{{appStrings.noEntriesFound}}</span>
</div>
</ng-template>
